import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY as crumbLabel } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

const edit = {
	ServPersProvozId: null as number | null,
	ProvozovnaId: null as number | null,
	ProvozovnaText: null as string | null,
	PracovnikId: null as number | null,
	PracovnikOsobniCis: null as string | null,
	PracovnikText: null as string | null,
	VyrobekvozOzn: null as string | null,
	VyrobekvozText: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel,
	dropdownList: {
		VyrobekvozOzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[types.mutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.edit.PracovnikId = data.value;
			state.edit.PracovnikOsobniCis = data.osobniCis;
			state.edit.PracovnikText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
		},
	},
	extraGetters: {},
	props: {
		mode: null,
	},
});
